import { render, staticRenderFns } from "./prompt-list-query-edit.vue?vue&type=template&id=1942bd71"
import script from "./prompt-list-query-edit.vue?vue&type=script&lang=js"
export * from "./prompt-list-query-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports